import React from "react";
import { db } from "../firebase";
import { IoMdClose } from "react-icons/io";
import gif from "../svg x gifs/Emails.gif";
import { addDoc, collection } from "firebase/firestore";
function Footer() {
  const [nameinp, setname] = React.useState({ email: "" });
  const [popup, setPopup] = React.useState(false);

  function InpClicked(e) {
    const { name, value } = e.target;
    setname((prevdata) => {
      return { ...prevdata, [name]: value };
    });
  }
  function submit(e) {
    e.preventDefault();
    let email = document.getElementById("emaila");
    if (email.value === "") {
    } else {
      addDoc(collection(db, "Newsletters"), nameinp)
        .then(() => {
          setPopup(true);
        })
        .catch((error) => {
          alert(error.message);
        });
      setname({ email: "" });
    }
  }

  return (
    <div className="mt-[300px] phonex2:mt-[400px] z-50  relative">
      <div className="flex shadow-2xl demitablet:flex-wrap demitablet:justify-center demitablet:space-y-8  -bottom-20 absolute bg-white w-full items-center rounded-md justify-between px-32 phonex2:px-8 phonex2:text-center demitablet:px-24  py-16">
        <div>
          <h1 className="demitablet:text-[30px] font-font1 text-[38px] leading-9">
            Subscribe Newsletter
          </h1>
          <p className="demitablet:text-[14px] text-md text-gray-700 mt-2">
            financial transactions remotely using a mobile
          </p>
        </div>
        <>
          {popup && (
            <div
              onClick={() => setPopup(false)}
              className="fixed z-[10000000] inset-0 bg-gray-900 bg-opacity-50  overflow-y-hidden flex justify-center items-center "
            />
          )}
          <div
            className={`${
              popup
                ? "w-auto scale-100 duration-700  max-auto z-[100000000] rounded-lg fixed -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 bg-white shadow-lg"
                : "scale-0  duration-700"
            }`}
          >
            {popup && (
              <div className="flex  flex-col justify-center phonex2:w-[20rem]  w-[35rem] h-[22rem]  ">
                <div className="flex justify-center">
                  {" "}
                  <img src={gif} className="max-h-[200px] " alt="" />
                </div>
                <div className="flex flex-col justify-center">
                  <h1 className="flex justify-center text-[30px] font-font1">
                    Subscribed!
                  </h1>
                  <p className="font-font phonex2:px-10 flex justify-center">
                    you have been successfully subscribed to newsletter!
                  </p>
                </div>
              </div>
            )}

            <div
              onClick={() => setPopup(false)}
              className="fixed right-0 cursor-pointer -top-16 bg-primary-100 w-12 h-12 rounded-full flex justify-center items-center"
            >
              <IoMdClose className="text-white text-xl" />
            </div>
          </div>{" "}
        </>
        <form
          onSubmit={submit}
          className="rounded-md phonex2:flex-wrap flex gap-2"
        >
          <input
            value={nameinp.email}
            onChange={InpClicked}
            type="email"
            name="email"
            id="emaila"
            placeholder="Enter your Email here.."
            className="py-4 px-4 text-[14px] md:text-[16px] md:px-10  phonex2:w-full focus:ring-2 focus:ring-gray-900 rounded-md outline-none "
          />
          <button className="w-full py-4 tablet:py-4 tablet:px-6 hover:bg-white hover:text-gray-900 border-2 border-gray-900/0 hover:border-gray-900 duration-700 px-10 font-font1 font-light rounded-md bg-gray-900 text-white">
            Get Start
          </button>
        </form>
      </div>
    </div>
  );
}

export default Footer;
